import { parseCookies } from 'nookies';

export const getFacebookData = (req?: any) => {
  const cookies = parseCookies({ req });
  const fbp = cookies['_fbp'] || null;
  const fbc = cookies['_fbc'] || null;
  const c_user = cookies['c_user'] || null;
  return { fbp, fbc, c_user };
};
